<template>
  <section>
    <div class="w-full bg-white rounded-md mt-2 p-4">
      <div class="w-full flex gap-2 items-center">
        <i class="pi pi-list"></i>
        <p class="text-lg font-bold">Listado de Modalidades de contrato</p>
        <Button @click="actionModal" class="ml-auto rounded-md" label="Crear Mod Contrato"/>
      </div>
      <div class="grid grid-cold-1 md:grid-cols-2 lg:grid-cols-5 gap-2 my-2">
        <!-- filtro por codigos de articulo -->
        <div class="w-full">
          <label class="text-xs text-gray-600" for="cod_bod">Código de la modalidad</label>
          <InputText class="w-full" id="cod_bod" @keyup.enter="listar" v-model="filtros.value"/>
        </div>
        <!-- filtro por descripcion -->
        <div class="w-full">
          <label class="text-xs text-gray-600" for="descripcion">Nombre</label>
          <InputText class="w-full" id="descripcion" v-model="filtros.descripcion"/>
        </div>
        <!-- filtro por modalidad -->
        <div class="flex gap-2">
          <Button @click="listar" class="mt-5 mb-1.5 rounded-md" label="Buscar"/>
          <Button @click="limpiarFiltros" class="mt-5 mb-1.5 rounded-md p-button-outlined p-button-secondary"
                  label="Limpiar"/>
        </div>
      </div>
      <div class="w-full my-2">
        <DataTable class="p-datatable-sm text-xs" :value="datosDatatable.rows" responsiveLayout="scroll">
          <Column header="Id">
            <template #body="{data}">
              <div class="pt-3">
                <p>{{ data.id }}</p>
                <div class="flex gap-x-4 hover:text-blue-600 text-white transition ease-in-out duration-500">
                  <button class="underline italic" @click='edit(data)'>Editar</button>
                </div>
              </div>
            </template>
          </Column>
          <Column field="value" header="Codigo"></Column>
          <Column field="descripcion" header="Nombre"></Column>

          <Column header="Acciones">
            <template #body="{data}">
              <div class="p-2 rounded-md">
                <Button
                  @click='remove(data.id)'
                  severity="danger"
                  v-tooltip="'Eliminar'"
                  class='p-button-rounded p-button-icon-only mx-2'
                >
                  <i class="pi pi-trash text-white"></i>
                </Button>
              </div>
            </template>
          </Column>
        </DataTable>
        <Paginator v-model:first="offset"
                   :rows="limit"
                   :totalRecords="parseInt(datosDatatable.count)"
                   :rowsPerPageOptions="[2,10,20,30,100]"
                   @page="onPage($event)"
        />
      </div>
    </div>
    <Dialog
      :header="update ? 'Actualizar Modalidad de Contrato' : 'Crear Modalidades de Contrato'"
      v-model:visible="displayModalModalidad"
      :breakpoints="{'960px': '100vw', '640px': '100vw'}"
      :style="{width: '30vw'}"
      :modal="true"
    >
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-2">
          <span>Nombre modalidad</span>
          <InputText v-model="newModalidad.descripcion" class="w-full" placeholder="Nombre"/>
        </div>
        <div class="flex flex-col gap-2">
          <span>Codigo modalidad</span>
          <InputText v-model="newModalidad.value" class="w-full" placeholder="Codigo"/>
        </div>
      </div>
      <template #footer>
        <Button label="Cerrar" icon="pi pi-times" @click="actionModal" class="p-button-xs p-button-danger"/>
        <Button v-if="!update" label="Guardar" icon="pi pi-check" @click="create" class="p-button-xs p-button-success" autofocus/>
        <Button v-else label="Actualizar" icon="pi pi-check" @click="editItem" class="p-button-xs p-button-success" autofocus/>
      </template>
    </Dialog>
    <Toast/>
  </section>
</template>
<script setup>
import { useToast } from 'primevue/usetoast'
import Swal from 'sweetalert2'
import ModalidadContratoService from '../../../../../services/modalidad-contrato.service'
import { onMounted, ref, computed } from 'vue'

const toast = useToast()
const _ModalidadContratoService = ref(new ModalidadContratoService())

// Referencias
const update = ref(false)
const idUpdate = ref(null)
const datosDatatable = ref([])
const newModalidad = ref({})
const limit = ref(10)
const offset = ref(0)
const filtros = ref({
  ItemName: null,
  CardCode: null
})
const displayModalModalidad = ref(false)
const params = computed(() => {
  return {
    limit: limit.value,
    offset: offset.value,
    ...filtros.value
  }
})

// Metodos
const onPage = ({ first, page, pageCount, rows }) => {
  limit.value = rows
  listar(params.value)
}
const listar = () => {
  const object = {
    ...params.value,
    limit: limit.value,
    offset: offset.value
  }
  _ModalidadContratoService.value.paginate(object).then(({ data }) => {
    datosDatatable.value = data
  })
}
const edit = (data) => {
  idUpdate.value = data.id
  actionModal()
  update.value = true
  newModalidad.value.value = data.value
  newModalidad.value.descripcion = data.descripcion
}
const editItem = () => {
  _ModalidadContratoService.value.put({ id: idUpdate.value, body: newModalidad.value }).then(({ data }) => {
    if (data.error) {
      console.error('Error al actualizar la modalidad, por favor intente nuevamente')
    } else {
      toast.add({ severity: 'success', summary: 'Exito', detail: 'Modalidad actualizada exitosamente', life: 3000 })
      listar()
      actionModal()
    }
  })
}
const remove = (id) => {
  Swal.fire({
    title: 'Advertencia',
    text: '¿Está seguro que desea eliminar la modalidad?',
    showDenyButton: true,
    denyButtonText: 'Cancelar',
    confirmButtonText: 'Eliminar'
  }).then((result) => {
    if (result.isConfirmed) {
      _ModalidadContratoService.value.delete(id).then(({ data }) => {
        if (data.error) {
          console.error('Error al eliminar la modalidad, por favor intente nuevamente')
        } else {
          toast.add({ severity: 'success', summary: 'Exito', detail: 'Modalidad eliminada exitosamente', life: 3000 })
          listar()
        }
      })
    } else if (result.isDenied) {
      Swal.fire('Modalidad no eliminada', '', 'info')
    }
  })
}
const limpiarFiltros = () => {
  filtros.value = {
    descripcion: null,
    value: null
  }
  listar()
}
const actionModal = () => {
  update.value = false
  displayModalModalidad.value = !displayModalModalidad.value
  newModalidad.value = {}
}
const create = () => {
  if (!newModalidad.value.descripcion || !newModalidad.value.value) {
    toast.add({ severity: 'error', summary: 'Error', detail: 'Por favor ingrese todos los campos', life: 3000 })
    return
  }
  _ModalidadContratoService.value.post(newModalidad.value).then(({ data }) => {
    toast.add({ severity: 'success', summary: 'Exito', detail: 'Modalidad creada exitosamente', life: 3000 })
    console.log(data)
    actionModal()
    listar()
  }).catch((error) => {
    toast.add({ severity: 'error', summary: 'Error', detail: 'Error al crear la modalidad', life: 3000 })
    console.error(error)
  })
}

onMounted(() => {
  listar({
    limit,
    offset
  })
})
</script>
<style>
.p-dropdown-label {
  font-size: 0.75rem !important
}

.tipoId .p-dropdown-trigger {
  display: none !important;
}

::-webkit-scrollbar-thumb {
  background: rgb(189, 189, 189);
  border-radius: 9999px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

::-webkit-input-placeholder { /* Edge */
  color: gray;
}

::-webkit-scrollbar {
  width: 0.4rem;
}
</style>
